/* eslint-disable dot-notation */
import { ReactElement, useEffect } from 'react';

import { Loading } from '@betrybe/ada-react';
import { useHistory } from 'react-router-dom';
import { DefaultLayout } from '@/layouts/index';
import { useClient, useToken } from '@/hooks';

function RedirectEducation(): ReactElement {
  const history = useHistory();
  const client = useClient();
  const token = useToken();

  useEffect(() => {
    const path = window.location.pathname;

    if (path === '/forgot-password') {
      setTimeout(() => {
        window.location.href = process.env['REACT_APP_FORGOT_PASSWORD_URL'];
      }, 2000);
    } else {
      setTimeout(() => {
        client.clearAll();
        token.removeToken();
        window.location.href = process.env['REACT_APP_EDUCATION_URL'];
      }, 3000);
    }
  }, [client, history, token]);

  return (
    <DefaultLayout cardSize="normal-card">
      <div className="redirect-container">
        <Loading />

        <p className="redirect-container__title">Saindo da Tela de Saldo...</p>

        <p>Redirecionando para Trybe</p>
      </div>
    </DefaultLayout>
  );
}

export default RedirectEducation;
